export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manawubrg.0dbdfcc3.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};